import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GLOBAL } from '../global';
import { Observable } from 'rxjs';
import { Direccion } from '../domain/direccion';

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  urlBase: string;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  /**
   * @author Frank Edward Daza González
   * @version 2018-10-29
   * @param httpClient 
   */
  constructor(public httpClient: HttpClient) {
    this.urlBase = GLOBAL.URL_BASE + 'sicaDireccion';
   }

   /**
    * Retorna todas las direcciones activas asociadas a un cliente.
    * 
    * @author Frank Edward Daza González
    * @version 2018-10-29  
    * @param direccion 
    */
   findAllDireccionesActivasByTercId(direccion: Direccion): Observable<any> {     
    return this.httpClient.post(this.urlBase + '/findAllDireccionesActivasByTercId/', direccion, this.httpOptions);
   }

   /**
    * Crea una dirección asociada a un cliente.
    * 
    * @author Frank Edward Daza González
    * @version 2018-10-29
    * @param direccion 
    */
   saveClientAddress(direccion: Direccion): Observable<any> {
    return this.httpClient.post(this.urlBase + '/saveClientAddress/', direccion, this.httpOptions);
   }

   /**
    * Actualiza la dirección asociada a un cliente.
    * 
    * @author Frank Edward Daza González
    * @version 2018-10-31
    * @param direccion 
    */
   updateClientAddress(direccion: Direccion): Observable<any> {
    return this.httpClient.post(this.urlBase + '/updateClientAddress/', direccion, this.httpOptions);
   }

}
